export const ConfettoWidth = 8;
export const ConfettoHeight = 14;

export const ConfettoXRotMult = 2;
export const ConfettoYRotMult = 3;
export const ConfettoZRotMult = 4;
